const NotFound = () => {
    return <h2 className="center-box">
        Page Not Found
    </h2>
}

export default NotFound
